import { createAction } from '@ngrx/store'
export const flushDashboardState = createAction('[Dashboard] Flush Dashboard State')
